import { extendTheme } from '@chakra-ui/react';
import {
  BG_ALTERNATIVE,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_ALTERNATIVE,
  BG_OPACITY,
  ASSETS_PRIMARY,
  COLOR_1,
  COLOR_2,
  COLOR_3,
  COLOR_4,
  COLOR_5,
  COLOR_6,
  COLOR_7,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    body_lv2: FONT_FAMILY.body_lv2,

    // for generator purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '42px',
    subHeading: '42px',
    body: '14px',
    body_lv2: '17px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 300,
    body_lv2: 500,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
        '--fontItalic-and': '',
      },
    },
  },
  colors: {
    color1: COLOR_1,
    color2: COLOR_2,
    color3: COLOR_3,
    color4: COLOR_4,
    color5: COLOR_5,
    color6: COLOR_6,
    color7: COLOR_7,

    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    mainAssetColor: ASSETS_PRIMARY,
    bgOpacity: BG_OPACITY,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    alternativeColorText: TEXT_ALTERNATIVE,
    transparent: 'transparent',
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
    Button: {
      baseStyle: {
        fontFamily: 'subHeading',
      },
    },
  },
};

export default extendTheme(theme);
